import axios from 'axios';
import router from '@/router/index.js';
import store from '@/store';
import { Message } from 'element-ui'

// 创建一个axios实例
const service = axios.create({
    baseURL: '/', // url = base url + request url
    withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout 10s
});

// 请求拦截器
service.interceptors.request.use(config => {
    // do something before request is sent
    const token = store.state.token;
    //console.log(token,'token')
    // 如果当前存有token,就加在请求头上
    if (token) {
        config.headers['token'] = `${token}`;
    }

    return config;
}, error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(response => {
    //do something before response
    if (response.data.code == 1) {
        return response;
    } else if (response.data.code == -1) {//登录失效回到登录页面
        Message.warning('登录失效，请重新登录！');
        localStorage.clear();
        setTimeout(function () {
            router.replace({
                path: '/login',
            })
        }, 1000)
    } else {
        //24.9.29 判断是否是获取小程序码接口 dxm
        if (response.config.url.includes("exhibitor/company/getUnlimited")) {
            return response;
        }
        // 24.8.22 判断是否是询盘导出接口,询盘导出接口成功返回2 dxm
        if (response.config.url.includes("SeekSample/lists") && response.data.code == 2) {
            return response;
        } else {
            Message.error(response.data.msg);
        }
    }
},
    error => {
        console.log('err' + error); // for debug
        if (error.response.data.code == 1) {
            router.replace({
                path: '/login',
            })
        } else {
            Message.warning(error.response.data.data);
        }
        return Promise.reject(error);
    })

export default service;